// React
import React, { useContext, useState } from "react";

const AiChatContext = React.createContext();

function AiChatProvider({ children }) {
    const [prompt, setPrompt] = useState(null);
    const [attachments, setAttachments] = useState([]);

    const submit = (value) => {
        setPrompt(value.Prompt);
        setAttachments(value.Attachments || []);
    };

    const clear = () => {
        setPrompt(null);
    };

    return (
        <AiChatContext.Provider value={{ prompt, attachments, submit, clear }}>
            {children}
        </AiChatContext.Provider>
    );
}

function useAiChatContext() {
    const aiChatContext = useContext(AiChatContext);
    return aiChatContext;
}

export { AiChatProvider, useAiChatContext };
